// extracted by mini-css-extract-plugin
module.exports = {"outer":"DatacommonsLogo_outer__2ov_W","inner":"DatacommonsLogo_inner__wt58p","light":"DatacommonsLogo_light__1jZaW","dark":"DatacommonsLogo_dark___tCVh"};